import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';

// @todo CTE-214 work with Chan to define loading state for overall component
export const TemplatePanel: LoadableType<{
	parentPageId: string;
	currentSpaceKey: string;
	contentId: string;
	isPanelDisabled?: boolean;
	onContentUpdated?: () => void;
	beforeTemplateSelect?: () => void;
	beforeUpdateRequest?: () => void;
	onError?: () => void;
	hasUserAddedContent: boolean | null;
	title: string;
	templateAllowList?: string[];
	isAlwaysDiscardChanges?: boolean;
	isSpacePickerDisabled?: boolean;
}> = LoadableAfterPaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-TemplatePanel" */ './TemplatePanel.tsx'))
			.TemplatePanel,
});
